import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';

const css = ".ispui-select-apply{display:block}.ispui-select-apply__button+.ispui-select-apply__button{margin-left:var(--ispui-select-apply__button-mr, 5px)}";

const Apply = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.apply = createEvent(this, "apply", 7);
    this.reset = createEvent(this, "reset", 7);
    /** apply button text */
    this.applyText = 'Применить';
    /** reset button text */
    this.resetText = 'Сбросить';
    /** wether to show reset button */
    this.withReset = true;
  }
  render() {
    return (h(Host, { class: "ispui-select-apply" }, h("button", { class: "ispui-button ispui-select-apply__button ispui-select-apply__button_apply", onClick: () => this.apply.emit() }, this.applyText), this.withReset && (h("button", { class: "ispui-button ispui-button_theme_inline-blue ispui-select-apply__button ispui-select-apply__button_reset", onClick: () => this.reset.emit() }, this.resetText))));
  }
  static get style() { return css; }
}, [0, "ispui-select-apply", {
    "applyText": [1, "apply-text"],
    "resetText": [1, "reset-text"],
    "withReset": [4, "with-reset"]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["ispui-select-apply"];
  components.forEach(tagName => { switch (tagName) {
    case "ispui-select-apply":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, Apply);
      }
      break;
  } });
}

const IspuiSelectApply = Apply;
const defineCustomElement = defineCustomElement$1;

export { IspuiSelectApply, defineCustomElement };
